import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.326 7.306A10.75 10.75 0 0 1 12 1.25c5.937 0 10.75 4.813 10.75 10.75S17.937 22.75 12 22.75 1.25 17.937 1.25 12c0-1.683.387-3.276 1.076-4.694m.875 1.832A9.2 9.2 0 0 0 2.75 12a9.25 9.25 0 0 0 5.588 8.497l3.5-3.25a5.24 5.24 0 0 1-3.874-1.89.8.8 0 0 1-.123-.127zm3.586 2.233L3.884 7.56A9.25 9.25 0 0 1 12 2.75a9.24 9.24 0 0 1 7.617 4H12a5.25 5.25 0 0 0-5.213 4.621M12 8.25a3.75 3.75 0 1 0 2.294 6.717l.018-.017a1 1 0 0 1 .098-.077A3.75 3.75 0 0 0 12 8.25m3.27 7.858A5.24 5.24 0 0 0 17.25 12a5.23 5.23 0 0 0-1.576-3.75h4.784A9.25 9.25 0 0 1 9.972 21.027z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }